import React, { useMemo } from 'react';
import BannerBlockItem, { BannerItemProps } from './BannerBlockItem';
import clsx from 'clsx';
import { LinkModel } from '../../Types/LinkModel';

export interface BannerBlockProps {
  banners: BannerItemProps[];
  numPerRow: number;
  systemId: string;
  fullwidth: boolean;
  title?: string;
  link?: LinkModel;
}

const bannerCellClass = {
  1: 'grid-cols-1',
  2: 'grid-cols-1 sm:grid-cols-2',
  3: 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3',
  4: 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4',
  5: 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-5',
  6: 'grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-6',
};

const BannerBlock = ({
  systemId,
  banners,
  numPerRow,
  fullwidth,
  title,
  link,
}: BannerBlockProps) => {
  return banners?.length > 0 ? (
    <>
      {title && (
        <div className="container mb-4 flex items-center justify-between md:mb-6">
          <h2 className="uppercase">{title}</h2>
          {link?.href && (
            <a href={link.href} className="text-xl underline">
              {link.text}
            </a>
          )}
        </div>
      )}
      <div
        className={clsx(
          'container',
          fullwidth && 'px-0',
          fullwidth && 'max-w-none',
          !fullwidth &&
            '[&_.banner-item]:overflow-hidden [&_.banner-item]:rounded',
          'overflow-x-hidden'
        )}
      >
        <div
          className={`grid ${bannerCellClass[numPerRow]} gap-4 md:gap-6`}
        >
          {banners.map((banner, idx) => (
            <BannerBlockItem
              {...banner}
              key={'banner-block' + idx + systemId}
            />
          ))}
        </div>
      </div>
    </>
  ) : null;
};

export default BannerBlock;
